module.exports = __webpack_public_path__ + "static/media/c4_mobile.46078d78.png";